import "./css/AboutUs.css";
import "./css/Complaints.css";
import React from "react";
import { FaBook, FaDownload } from "react-icons/fa";

const LegislationDocuments = () => {
  return (
    <div className="about-us">
      {/* === Header Section === */}
      <section className="about-header testing-header">
        <div className="overlay">
          <h1 className="page-title">Cess & Metrology Regulations</h1>
          <p className="subtitle">
            Access downloadable versions of Cess and Metrology Acts and Regulations below.
          </p>
        </div>
      </section>

      {/* === CESS REGULATIONS === */}
      <section className="how-it-works">
        <h2>CESS REGULATIONS</h2>
        <div className="steps-container single-card">
          <div className="step-card">
            <div className="icon-circle">
              <FaBook className="info-icon" />
            </div>
            <h3>Cess Regulations</h3>
            <p>
              Take a look at the Cess Regulations. Click the link below to download.
            </p>
            <a
              href="/files/Cess-gazette-2016.pdf"
              download
              className="download-btn"
              style={{ color: "#ff6600"}}
            >
              <FaDownload className="download-icon" /> Download
            </a>
          </div>
        </div>
      </section>

      {/* === METROLOGY ACT & REGULATIONS === */}
      <section className="how-it-works">
        <h2>METROLOGY ACT & REGULATIONS</h2>
        <div className="steps-container">
          {/* Document 1 */}
          <div className="step-card">
            <div className="icon-circle">
              <FaBook className="info-icon" />
            </div>
            <h3>Metrology Act</h3>
            <p>
              Take a look at the Metrology Act. Click the link below to download.
            </p>
            <a
              href="/files/Metrology-Act-No.10-of-2016without-notes.pdf"
              download
              className="download-btn"
              style={{ color: "#ff6600"}}
            >
              <FaDownload className="download-icon" /> Download
            </a>
          </div>

          {/* Document 2 */}
          <div className="step-card">
            <div className="icon-circle">
              <FaBook className="info-icon" />
            </div>
            <h3>Metrology Regulations March 2021</h3>
            <p>
              Take a look at the Metrology Regulations March 2021. Click the link below to download.
            </p>
            <a
              href="/files/Metrology-Regulations-March-2021-rev1-002.pdf"
              download
              className="download-btn"
              style={{ color: "#ff6600"}}
            >
              <FaDownload className="download-icon" /> Download
            </a>
          </div>

          {/* Document 3 */}
          <div className="step-card">
            <div className="icon-circle">
              <FaBook className="info-icon" />
            </div>
            <h3>Govt Notice No. 60 – Metrology (Type Approval) Regulations 2021</h3>
            <p>
              Take a look at the Govt Notice No. 60 – Metrology (Type Approval Administrative)
              Regulations 2021. Click the link below to download.
            </p>
            <a
              href="/files/Govt-Notice-No.-60-Metrology.pdf"
              download
              className="download-btn"
              style={{ color: "#ff6600"}}
            >
              <FaDownload className="download-icon" /> Download
            </a>
          </div>

          {/* Document 4 */}
          <div className="step-card">
            <div className="icon-circle">
              <FaBook className="info-icon" />
            </div>
            <h3>Govt Notice No. 12 – Metrology (Sale of Articles) Amendment 2022</h3>
            <p>
              Take a look at the Govt Notice No. 12 – Metrology (Sale of Articles)
              (Amendment) Regulations 2022. Click the link below to download.
            </p>
            <a
              href="/files/Govt-Notice-No.-12-Metrology.pdf"
              download
              className="download-btn"
              style={{ color: "#ff6600"}}
            >
              <FaDownload className="download-icon" /> Download
            </a>
          </div>
        </div>
      </section>
    </div>
  );
};

export default LegislationDocuments;
